	export enum RecommendationDurationEnum {
		DurS = 1,
		Dur0 = 2,
		Dur1 = 3,
		Dur5 = 4
	}
